module.exports = __webpack_public_path__ + "7cc6ded1bc82cad153f38b4bfdbebe00.pdf";